import Input from './components/Input.vue'
import './styles/less/index.less'

export default Input


// WEBPACK FOOTER //
// ./src/index.js